import React from 'react';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { makeStyles } from 'tss-react/mui';
import MissingInterviews from 'app/assets/images/CandidateProfile/MissingInterviews.svg';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const noPlacementStyles = makeStyles()(() => ({
  noPlacementDataText: {
    fontStyle: 'italic',
    fontSize: '14px',
  },
  noPlacementDataContainer: {
    textAlign: 'center',
    paddingTop: '125px',
    maxHeight: 570,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}));

export const CredentialingNoPlacementData = () => {
  const { classes } = noPlacementStyles();
  const { t } = useTranslation();
  return (
    <LayoutGrid container direction="column" spacing={4} className={classes.noPlacementDataContainer}>
      <LayoutGridItem>
        <img src={MissingInterviews} alt="No Placement Data" />
      </LayoutGridItem>
      <LayoutGridItem>
        <Typography className={classes.noPlacementDataText}>
          {t('placement.profile.tabs.credentialingTab.noPlacements')}
        </Typography>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
